import {
  // GET_PRODUCTS,
  SET_ALL_PRODUCTS,
  SET_PRODUCTS,
  // SET_LOADING,
} from "../../types";

const ProductReducer = (state, action) => {
  switch (action.type) {
    // case SET_LOADING:
    //   return { ...state, products_loading: true };

    // case GET_PRODUCTS:
    //   return { ...state, products: action.payload, products_loading: false };

    case SET_ALL_PRODUCTS:
      return { ...state, all_products: action.payload };

    case SET_PRODUCTS:
      return { ...state, products: action.payload };

    default:
      return state;
  }
};

export default ProductReducer;